import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { IS_DEV_AUTH } from "@/auth/AuthProvider";

export default function Auth() {
  const { isAuthenticated, signIn } = useAuth();
  const navigate = useNavigate();

  // Em dev, sempre estamos "autenticados" -> vai direto pra home
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{
        background: "linear-gradient(160deg, #04265a 0%, rgb(0,56,130) 55%, #04224f 100%)",
      }}
    >
      <div
        className="w-full max-w-md rounded-3xl px-8 py-10 shadow-2xl"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.06)",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          backdropFilter: "blur(8px)",
        }}
      >
        {/* Logo */}
        <div className="flex justify-center">
          <img
            src="/Logo JC Azul.png"
            alt="JusCapital"
            className="h-12 w-auto rounded-md"
          />
        </div>

        {/* Titulo + subtitulo */}
        <div className="mt-8 text-center">
          <h1 className="text-xl font-bold tracking-tight text-white">
            Client Relationship Management
          </h1>
          <p className="mt-2 text-sm text-white/60">
            {IS_DEV_AUTH
              ? "Local sandbox - simulated authentication"
              : "Access requires administrator approval"}
          </p>
        </div>

        {/* Botao Microsoft */}
        {!IS_DEV_AUTH && (
          <button
            type="button"
            onClick={() => signIn()}
            className="mt-8 w-full inline-flex items-center justify-center gap-2 rounded-lg bg-white px-4 py-3 text-sm font-semibold text-slate-800 hover:bg-white/90 transition-colors"
          >
            <svg width="18" height="18" viewBox="0 0 23 23" aria-hidden>
              <rect width="10" height="10" x="1" y="1" fill="#F25022" />
              <rect width="10" height="10" x="12" y="1" fill="#7FBA00" />
              <rect width="10" height="10" x="1" y="12" fill="#00A4EF" />
              <rect width="10" height="10" x="12" y="12" fill="#FFB900" />
            </svg>
            Sign in with Microsoft
          </button>
        )}

        {/* Divisor OR */}
        {!IS_DEV_AUTH && (
          <div className="my-4 flex items-center gap-3">
            <div className="h-px flex-1 bg-white/15" />
            <span className="text-[11px] font-medium text-white/40">OR</span>
            <div className="h-px flex-1 bg-white/15" />
          </div>
        )}

        {/* Botao email/senha - desabilitado (em breve) */}
        {!IS_DEV_AUTH && (
          <button
            type="button"
            disabled
            title="Coming soon"
            className="w-full inline-flex items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-medium text-white/45 cursor-not-allowed"
            style={{ backgroundColor: "rgba(255, 255, 255, 0.08)" }}
          >
            Sign in with email and password
            <span className="text-[10px] uppercase tracking-wide text-white/35">(soon)</span>
          </button>
        )}

        {IS_DEV_AUTH && (
          <p className="mt-8 text-xs text-center text-white/50">
            Use the yellow selector in the bottom right corner to switch users.
            Redirecting...
          </p>
        )}
      </div>

      {/* Rodape fora do card */}
      {!IS_DEV_AUTH && (
        <p className="mt-6 text-xs text-center text-white/45">
          Use your corporate Microsoft account to access.
          <br />
          Authorized domains: @juscapital.com.br and @dsvv.com.br
        </p>
      )}
    </div>
  );
}
